/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Final_TitleInputs */

const da_forside_final_title = /** @type {(inputs: Forside_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar til at prøve?`)
};

/** @type {(inputs: Forside_Final_TitleInputs) => LocalizedString} */
const en_forside_final_title = da_forside_final_title;

/**

* @param {Forside_Final_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_final_title = /** @type {((inputs?: Forside_Final_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Final_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_final_title(inputs)
	return /** @type {LocalizedString} */ ("Klar til at prøve?")
});